/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ImpersonationStartRequestDto interface.
 */
export function instanceOfImpersonationStartRequestDto(value) {
    return true;
}
export function ImpersonationStartRequestDtoFromJSON(json) {
    return ImpersonationStartRequestDtoFromJSONTyped(json, false);
}
export function ImpersonationStartRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
export function ImpersonationStartRequestDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'reason': value['reason'],
    };
}
